import { X } from "lucide-react";

// RecentPairs
// - Desktop: wrapping flex row with "Clear" trailing link
// - Mobile: horizontally scrollable strip with momentum, taller chips for tap targets
//
// The `mobile` prop is passed from the parent (Battlefield) which owns
// useIsMobile().

export default function RecentPairs({ pairs, currentSymbol, onPick, onRemove, onClear, mobile = false }) {
  if (!pairs || pairs.length === 0) return null;

  const inner = pairs.map((p) => {
    const isCurrent = p.symbol === currentSymbol;
    const base = `group cb-hud-chip flex items-center gap-1.5 pl-3 pr-1 transition-colors shrink-0 ${
      mobile ? "min-h-[44px] py-1.5" : "py-1"
    } ${isCurrent ? "!border-[#00FFA3]/40 !bg-[#025939]/30" : "hover:!bg-white/5"}`;
    return (
      <div key={p.symbol} className={base} data-testid={`recent-pair-${p.symbol}`}>
        <button
          type="button"
          onClick={() => onPick?.(p)}
          className="font-mono-tac text-[11px] font-bold tracking-wide text-white flex items-center gap-1"
          data-testid={`recent-pair-${p.symbol}-select`}
        >
          <span className="text-white/90">{p.base}</span>
          <span className="text-slate-500">/</span>
          <span className="text-slate-400">{p.quote}</span>
        </button>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove?.(p.symbol);
          }}
          className={`flex items-center justify-center text-slate-600 hover:text-white transition-opacity ${
            mobile ? "w-8 h-8 opacity-70" : "w-5 h-5 opacity-40 group-hover:opacity-100"
          }`}
          aria-label={`Remove ${p.symbol}`}
          data-testid={`recent-pair-${p.symbol}-remove`}
        >
          <X className="w-3 h-3" />
        </button>
      </div>
    );
  });

  if (mobile) {
    return (
      <div
        className="flex items-center gap-2 overflow-x-auto -mx-4 px-4 pb-1"
        style={{ scrollbarWidth: "none", WebkitOverflowScrolling: "touch" }}
        data-testid="recent-pairs"
        data-mobile="true"
      >
        <span className="font-mono-tac text-[9px] uppercase tracking-[0.28em] text-slate-500 pr-1 shrink-0">
          Recent
        </span>
        {inner}
        {pairs.length > 1 && (
          <button
            type="button"
            onClick={onClear}
            className="font-mono-tac text-[9px] uppercase tracking-[0.28em] text-slate-600 hover:text-[#FF2A2A] transition-colors pl-2 shrink-0"
            data-testid="recent-pairs-clear"
          >
            Clear
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="recent-pairs">
      <span className="font-mono-tac text-[9px] uppercase tracking-[0.28em] text-slate-500 pr-1">
        Recent
      </span>
      {inner}
      {pairs.length > 1 && (
        <button
          type="button"
          onClick={onClear}
          className="font-mono-tac text-[9px] uppercase tracking-[0.28em] text-slate-600 hover:text-[#FF2A2A] transition-colors pl-1"
          data-testid="recent-pairs-clear"
        >
          Clear
        </button>
      )}
    </div>
  );
}
